import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  InspectCollectVehicleDataService,
  VehicleDataRequest,
  VehicleDataOptions,
  VehicleDataResponse
} from '../../../../services/inspect-collect-vehicle-data.service';

@Component({
  selector: 'app-vehicle-data',
  templateUrl: './vehicle-data.component.html',
  styleUrls: ['./vehicle-data.component.scss']
})
export class AdminVehicleDataComponent implements OnInit {

  vehicleDataForm: FormGroup;
  isLoading = false;
  vehicleDataResponse: VehicleDataResponse | null = null;
  hasSubmitted = false;

  constructor(
    private formBuilder: FormBuilder,
    private vehicleDataService: InspectCollectVehicleDataService
  ) {
    this.vehicleDataForm = this.formBuilder.group({
      registration: ['', [Validators.required, Validators.pattern(/^[A-Z0-9\s]+$/i)]],
      mileage: ['', [Validators.min(0)]],
      vin: [''],
      autoTraderMetrics: [false],
      autoTraderFeatures: [false],
      autoTraderValuation: [false],
      capData: [false]
    });
  }

  ngOnInit(): void {
  }

  async onSubmit(): Promise<void> {
    if (this.vehicleDataForm.invalid) {
      this.markFormGroupTouched();
      return;
    }

    const formValue = this.vehicleDataForm.value;

    // Check if at least one data source is selected
    if (!formValue.autoTraderMetrics && !formValue.autoTraderFeatures &&
        !formValue.autoTraderValuation && !formValue.capData) {
      alert('Please select at least one data source.');
      return;
    }

    this.isLoading = true;
    this.hasSubmitted = true;
    this.vehicleDataResponse = null;

    try {
      const request: VehicleDataRequest = {
        registration: formValue.registration.toUpperCase().replace(/\s/g, ''),
        mileage: formValue.mileage || undefined,
        vin: formValue.vin || undefined
      };

      const options: VehicleDataOptions = {
        autoTraderMetrics: formValue.autoTraderMetrics,
        autoTraderFeatures: formValue.autoTraderFeatures,
        autoTraderValuation: formValue.autoTraderValuation,
        capData: formValue.capData
      };

      this.vehicleDataResponse = await this.vehicleDataService.getVehicleData(request, options);
    } catch (error) {
      console.error('Error fetching vehicle data:', error);
      this.vehicleDataResponse = {
        errors: ['An unexpected error occurred while fetching vehicle data.']
      };
    } finally {
      this.isLoading = false;
    }
  }

  private markFormGroupTouched(): void {
    Object.keys(this.vehicleDataForm.controls).forEach(key => {
      const control = this.vehicleDataForm.get(key);
      control?.markAsTouched();
    });
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.vehicleDataForm.get(fieldName);
    return !!(field && field.invalid && field.touched);
  }

  getFieldError(fieldName: string): string {
    const field = this.vehicleDataForm.get(fieldName);
    if (field?.errors) {
      if (field.errors['required']) {
        return `${fieldName} is required.`;
      }
      if (field.errors['pattern']) {
        return `${fieldName} contains invalid characters.`;
      }
      if (field.errors['min']) {
        return `${fieldName} must be a positive number.`;
      }
    }
    return '';
  }

  resetForm(): void {
    this.vehicleDataForm.reset();
    this.vehicleDataResponse = null;
    this.hasSubmitted = false;

    // Reset checkboxes to false
    this.vehicleDataForm.patchValue({
      autoTraderMetrics: false,
      autoTraderFeatures: false,
      autoTraderValuation: false,
      capData: false
    });
  }
}

